import {
  opportunitiesProductsDestroyMutation,
  opportunitiesProductsListQueryKey,
  opportunitiesRetrieveQueryKey
} from '@crm/api'
import { ConfirmModal } from '@crm/components'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'

import { useMutation } from '@tanstack/react-query'

import { App, message } from 'antd'

import { useParams } from 'react-router-dom'

import { ActionsType } from './types'

export const DeleteProduct = ({ product, onCancel, ...props }: ActionsType) => {
  const { invalidateQueries } = useInvalidatePredicateQueries()
  const { t } = useLocales()
  const { notification } = App.useApp()
  const { opportunityId } = useParams()

  const { mutate, isPending } = useMutation({
    ...opportunitiesProductsDestroyMutation(),
    onSuccess: () => {
      invalidateQueries([
        opportunitiesProductsListQueryKey(),
        opportunitiesRetrieveQueryKey({ path: { id: Number(opportunityId) } })
      ])

      notification.success({
        message: t('success.success'),
        description: t('success.success_data_delete')
      })

      onCancel?.()
    },
    onError: (error) => showApiErrors(error)
  })

  const onDelete = () => {
    if (!product?.id) {
      message.error(t('error.product_is_missing'))
    }

    mutate({ path: { id: Number(product?.id) } })
  }

  return (
    <ConfirmModal
      loading={isPending}
      onSuccess={onDelete}
      onCancel={onCancel}
      {...props}
    />
  )
}
